/* eslint-disable react-hooks/exhaustive-deps */
import React, { forwardRef, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
/** Common Components */
import CardSection from "../../../../../components/ui/card/CardSection";
import CenterModel from "../../../../../components/ui/centerModel/CenterModel";
import FinalMolGrid from "../../../../../components/FinalMolGrid/FinalMolGrid";
/** Common Services & Data Files */
import SwalAlert from "../../../../../services/swalService/SwalService";
import ToastService from "../../../../../services/toastService/ToastService";
import { decryptUrlData } from "../../../../../services/CryptoService";
import { ProjectModuleGridConfig } from "./config/ProjectModuel.data";
import AddProjectModule from "./ProjectModule/AddProjectModule";
/** RTK Query */
import {
  useDeleteProjectModuelMutation,
  useGetProjectModuelListMutation,
} from "../../../../../app/services/projectModuleAPI";

const Projectmodule = forwardRef((props, ref) => {
  const molGridRef = useRef();
  const { confirm } = SwalAlert();
  /* State*/
  const [isModelOpen, setisModelOpen] = useState(false);
  const [projectmoduleGridData, setProjectmoduleGridData] = useState();
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [selectedId, setSelectedId] = useState(null);
  const { id } = useParams();
  const componetData = decryptUrlData(id);
  // const componentId = componetData.projectComponentId;
  const projectId = componetData;
  // API'S Call
  const [getAllProjectmoduleList, {
    isLoading: isProjectmoduleListLoading,
    isSuccess: isProjectmoduleListSuccess,
    data: isLProjectmoduleListeData,
  },] = useGetProjectModuelListMutation();

  const [deleteProjectmodule, {
    isSuccess: isProjectmoduleDeleted,
    data: deleteProjectmoduleData
  },] = useDeleteProjectModuelMutation();

  //** useEffect's */

  useEffect(() => {
    if (isProjectmoduleListSuccess && isLProjectmoduleListeData) {
      if (isLProjectmoduleListeData.dataSource) {
        setProjectmoduleGridData(isLProjectmoduleListeData.dataSource);
      }
      if (isLProjectmoduleListeData.totalRecord) {
        setTotalRowCount(isLProjectmoduleListeData.totalRecord);
      }
    }
  }, [isProjectmoduleListSuccess, isLProjectmoduleListeData]);

  useEffect(() => {
    if (isProjectmoduleDeleted && deleteProjectmoduleData) {
      ToastService.success(deleteProjectmoduleData.errorMessage);
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      getProjectmoduleList(currentPageObject);
    }
  }, [isProjectmoduleDeleted, deleteProjectmoduleData]);

  useEffect(() => {
    if (molGridRef.current) {
      // const currentPageObject = ;
      getProjectmoduleList(molGridRef.current.getDefulatPageObject());
    }
  }, []);

  //** Funcation's */

  const getProjectmoduleList = (pageObject) => {
    const request = {
      pagination: {
        pageNumber: pageObject.pageNumber,
        pageSize: pageObject.pageSize,
      },
      filters: {
        searchText: props.search,
        searchStatusId: props.selectedStatusOptions,
      },
      // ComponentId: componentId,
      projectId: projectId
    };
    getAllProjectmoduleList(request);
  };

  const handleToggleModal = () => {
    setisModelOpen(true);
  };

  const onDeleteClick = (data) => {
    confirm(
      "Delete?",
      "Are you sure you want to Delete?",
      "Delete",
      "Cancel"
    ).then((confirmed) => {
      if (confirmed) {
        deleteProjectmodule(data.projectModuleId);
      }
    });
  };

  const onEditAction = (data) => {
    setSelectedId(data.projectModuleId);
    setisModelOpen(true);
  };

  const onSidebarClose = () => {
    if (molGridRef.current) {
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      getProjectmoduleList(currentPageObject);
    }
    setisModelOpen(false);
    setSelectedId(null);
  };

  const handlePageChange = (page) => {
    getProjectmoduleList(page);
  };

  const actionHandler = {
    EDIT: onEditAction,
    DELETE: onDeleteClick,
  };

  return (
    <>
      <CardSection
        isContentLoading={isProjectmoduleListLoading}
        cardTitle={"Project Module"}
        rightButton={true}
        buttonClassName="theme-btn"
        titleButtonClick={handleToggleModal}
        buttonText="Module"
        textWithIcon={true}
        iconName="material-symbols:add-rounded"
        fontIcon={true}
        searchInputName="Search by Project Name"
        searchInput={true}
      >
        <div className="project-modules">
          <div className="project-module pt-1 p-0 form-card">
            <div className="table-grid">
              <FinalMolGrid
                ref={molGridRef}
                configuration={ProjectModuleGridConfig}
                dataSource={projectmoduleGridData}
                isLoading={isProjectmoduleListLoading}
                allowPagination={true}
                pagination={{
                  totalCount: totalRowCount,
                  pageSize: 20,
                  currentPage: 1,
                }}
                onPageChange={handlePageChange}
                onActionChange={actionHandler}
              />
            </div>
          </div>

        </div>
      </CardSection>
      <div>
        {isModelOpen && (
          <CenterModel
            showModal={isModelOpen}
            handleToggleModal={onSidebarClose}
            modalTitle={
              selectedId ? "Update Project Module" : "Add Project Module"
            }
            modelSizeClass="w-40"
          >
            <AddProjectModule
              ProjectId={projectId}
              onSidebarClose={onSidebarClose}
              showModal={isModelOpen}
              // componentId={componentId}
              selectedId={selectedId}
            />
          </CenterModel>
        )}
      </div>
    </>
  );
});

Projectmodule.propTypes = {
  search: PropTypes.string,
  selectedStatusOptions: PropTypes.number,
  showBreadcome: PropTypes.bool,
};

export default Projectmodule;
